import { qtiTypes } from 'common/store/common/constants';
import { ActionMenuItem, ActionStatusService, FeatureContextMenu } from './interfaces';

export type HideResponseAreaParams = {
    featureContextMenu?: FeatureContextMenu;
    promotedActions?: string[];
    actionStatusService: ActionStatusService;
    featureState: any;
    featureName: string;
    contentItems?: any[];
};

export const getHideResponseAreaAction = (featureContextMenu?: FeatureContextMenu): ActionMenuItem | undefined => {
    if (!featureContextMenu) return null;
    const promoted = featureContextMenu.featureContextActions.filter((a: ActionMenuItem) => !a.isIndependent);
    return promoted.find((a: ActionMenuItem) => a.actionName === 'hideResponseArea');
};

export const isTestTakerPane = (featureName: string, featureState: any): boolean => {
    return (
        featureName === 'contentPreview'
        && Array.isArray(featureState?.panesList)
        && typeof featureState?.activeTabIndex === 'number'
        && featureState.panesList[featureState.activeTabIndex] === 'testTaker'
    );
};

export const hasExactlyExtendedTextAndContentBlock = (items: any[]): boolean => {
    if (!Array.isArray(items) || items.length !== 2) return false;
    const types = new Set(items.map((hit: any) => hit?.objectType));
    return types.has(qtiTypes.EXTENDED_TEXT) && types.has(qtiTypes.CONTENT_BLOCK) && types.size === 2;
};

export const isIocpHideResponseAreaEnabled = (): boolean => {
    return !!(window as any).marketplaceProperties?.ENABLE_HIDE_RESPONSE_AREA_IN_PREVIEW;
};

export const canShowHideResponseToggle = (params: { featureName: string; featureState: any; contentItems?: any[] }): boolean => {
    const { featureName, featureState, contentItems = [] } = params || {} as any;
    const paneOk = isTestTakerPane(featureName, featureState);
    const typesOk = hasExactlyExtendedTextAndContentBlock(contentItems);
    const mppEnabled = isIocpHideResponseAreaEnabled();
    return !!(paneOk && typesOk && mppEnabled);
};

export const shouldRenderHideResponseAreaToggle = (params: HideResponseAreaParams): { shouldShow: boolean; hideAction?: ActionMenuItem } => {
    const {
        featureContextMenu,
        promotedActions = [],
        actionStatusService,
        featureState,
        featureName,
        contentItems = [],
    } = (params || {}) as HideResponseAreaParams;

    const hideAction = getHideResponseAreaAction(featureContextMenu);
    if (!hideAction) return { shouldShow: false, hideAction: undefined };

    const promotedIncludes = promotedActions.includes('hideResponseArea');
    const visible = typeof actionStatusService?.isActionVisible === 'function'
        ? actionStatusService.isActionVisible('hideResponseArea')
        : true;

    const visibilityGatesSatisfied = canShowHideResponseToggle({ featureName, featureState, contentItems });

    const shouldShow = !!(promotedIncludes && visible && visibilityGatesSatisfied);
    return { shouldShow, hideAction };
};

export const FEATURE_ID_CONTENT_PREVIEW_AUTHOR_PREVIEW = 'feature_contentPreview_author_preview_0_0';
export const FEATURE_NAME_CONTENT_PREVIEW = 'contentPreview';
export const ACTION_HIDE_RESPONSE_AREA = 'hideResponseArea';
